import React from 'react';
import Svg, { Path } from 'react-native-svg';
import type { StyleProp, ViewStyle } from 'react-native';
import { ICONS } from '../theme';

interface IconProps {
  name: keyof typeof ICONS | string;
  size?: number;
  color?: string;
  strokeWidth?: number;
  style?: StyleProp<ViewStyle>;
}

/**
 * Renders one of the prototype's exact inline SVG icon paths (SK Hospitality.dc.html
 * ICONS map) via react-native-svg — same viewBox, stroke width, and round caps/joins as
 * every <svg> in the mockup. Works identically on web (RNW) and native.
 * Pass an explicit `color` — RN has no `currentColor` inheritance.
 */
export default function Icon({ name, size = 16, color = '#000', strokeWidth = 1.7, style }: IconProps) {
  const d = ICONS[name] ?? ICONS.info;
  return (
    <Svg viewBox="0 0 24 24" width={size} height={size} fill="none" style={style}>
      <Path d={d} stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
    </Svg>
  );
}
